<style>


.table-reset tr.course_schedule:hover td {
    background-color: #ececec !important;
    cursor: pointer;
}

.table-reset tr.course_schedule.selected td {
    background-color: #ccdbe5 !important;
    cursor: pointer;
    font-weight: bold;
}


</style>

<template>

    <div class="course-schedules-list">

        <div class="table-responsive">

            <table class="table table-reset">
                <thead>
                <tr>
                    <th></th>
                    <th>path</th>
                    <th>class</th>
                    <th>location</th>
                    <th>trainer</th>
                    <th>from</th>
                    <th>until</th>
                    <th>guests</th>
                </tr>
                </thead>
                <tbody v-for="day in courseSchedulesGrouped">
                <tr>
                    <th colspan="7">{{ dateFormat(day.date, 'dddd, MMMM D') }}</th>
                    <td><button class="btn btn-success" @click="addSchedule(day.date, 6)" v-if="allow.create">add class to schedule</button></td>
                </tr>

                <tr v-for="courseSchedule in day.course_schedules"
                    @click="showScheduleDetails(courseSchedule)"
                    class="course_schedule"
                    :class="{selected: courseSchedule.id === selectedCourseSchedule.id}"
                >
                    <td>{{ courseSchedule.id }}</td>
                    <td>{{ courseSchedule.path.name }}</td>
                    <td>{{ courseSchedule.course.name }}</td>
                    <td>{{ courseSchedule.location ? courseSchedule.location.name : 'no' }}</td>
                    <td>{{ courseSchedule.trainer ? courseSchedule.trainer.name : 'no' }}</td>
                    <td>{{ dateFormat(courseSchedule.from, 'hh:mm a') }}</td>
                    <td>{{ dateFormat(courseSchedule.till, 'hh:mm a') }}</td>
                    <td>
                        <span v-if="courseSchedule.guest_ids && Array.isArray(courseSchedule.guest_ids)">{{ courseSchedule.guest_ids.length }}</span>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
//
//const mixinDayJs = require('../../helpers/vue_mixins').mixinDayJs;
//const mixinErrorHandler = require('../../helpers/vue_mixins').mixinErrorHandler;

export default {
    // mixins: [mixinDayJs, mixinErrorHandler],
    props: {
        course_schedules: Array,
        filters: Object,
        permissions: Object
    },
    data() {
        return {
            courseSchedules: [],
            courseSchedulesGrouped: [],
            selectedCourseSchedule: {},
            allow: {
                create: true,
                show: true,
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.permissions) {
                _.merge(this.allow, this.permissions);
            }
            this.courseSchedules = this.course_schedules;
            this.groupScheduleDetails(this.courseSchedules);
        },
        groupScheduleDetails(courseSchedule) {
            this.courseSchedulesGrouped = _(courseSchedule)
                .sortBy(s => s.from)
                .groupBy(s => this.dateFormat(s.from, 'YYYY-M-D'))
                .map((value, key) => ({date: dayjs(key), course_schedules: value}))
                .value();
        },

        showScheduleDetails(courseSchedule) {
            if (this.allow.show) {
                this.selectedCourseSchedule = courseSchedule;
                this.$emit('details', {course_schedule: courseSchedule});
            }
        },

        addSchedule(day, hour) {
            if (this.allow.create) {
                const newDate = dayjs(day).clone().hour(hour).minute(0).second(0)
                this.$emit('create', {date: newDate});
            }
        },
    },
    watch: {
        course_schedules(newVal, oldVal) {
            this.init();
        }
    },
    computed: {}
}
</script>
